import { Component } from '@angular/core';
import { IzzyChannelTypeExtensionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Channel Type Extensions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzychanneltypeextension-form',
    templateUrl: './izzychanneltypeextension.form.component.html'
})
export class IzzyChannelTypeExtensionFormComponent extends BaseFormComponent {
    public record!: IzzyChannelTypeExtensionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'channelConfiguration', sectionName: 'Channel Configuration', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

